module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container module-wrapper"
  }, [_c('ul', {
    attrs: {
      "id": "ul2"
    }
  }, _vm._l((_vm.posts), function(item) {
    return _c('li', {
      staticClass: "gutter-14__li grid-4",
      staticStyle: {
        "padding-bottom": "3%",
        "padding-left": "0px"
      }
    }, [_c('div', {
      staticClass: "basic-card",
      staticStyle: {
        "border": "0px"
      }
    }, [_c('a', {
      staticClass: "basic-card-img-link",
      attrs: {
        "href": _vm.getUrl(item.id, item.sendPortal)
      }
    }, [_c('div', {
      staticClass: "background-image basic-card__img",
      staticStyle: {
        "width": "100%",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + _vm.getImageUrl(item.imageUrl, item.sendPortal) + ')'
      })
    }, [_c('p', {
      staticClass: "alt-text"
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), (item.sendPortal === 'CONFIRM') ? _c('a', {
      staticClass: "square-box__title__link2",
      staticStyle: {
        "height": "43px",
        "overflow": "hidden"
      },
      attrs: {
        "href": _vm.getUrl(item.id, item.sendPortal)
      }
    }, [_vm._v("[" + _vm._s(item.portalOrgName) + "]" + _vm._s(item.title))]) : _vm._e(), _vm._v(" "), (item.sendPortal !== 'CONFIRM') ? _c('a', {
      staticClass: "square-box__title__link2",
      staticStyle: {
        "height": "43px",
        "overflow": "hidden"
      },
      attrs: {
        "href": _vm.getUrl(item.id, item.sendPortal)
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "square-box__date2"
    }, [_vm._v(_vm._s(item.createdDate.substring(0, 10)))])])])
  }), 0)]), _vm._v(" "), (_vm.currentPage !== _vm.totalPages) ? _c('div', {
    staticClass: "show-more-wrapper"
  }, [_c('button', {
    staticClass: "more-btn btn--blue-line",
    attrs: {
      "id": "moreBtn",
      "title": "최신글 더보기"
    },
    on: {
      "click": function($event) {
        return _vm.getNextPage()
      }
    }
  }, [_vm._v("\n      더보기\n      "), _c('span', {
    staticClass: "more-btn__plugs-icon"
  }, [_vm._v("+")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01efcd73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/portal/PortalHomePost.vue
// module id = 1270
// module chunks = 6